<template>
  <div class="form">
    <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
      <el-form-item label="姓名" prop="user_name">
        <el-input v-model="form.user_name"></el-input>
      </el-form-item>

      <el-form-item label="电话" prop="mobile">
        <el-input v-model="form.mobile"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="from">
        <el-input v-model="form.from"></el-input>
      </el-form-item>

      <el-form-item label="留言" prop="contents">

        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="form.contents">
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="userSubmit" type="primary">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addContents } from '@/api/contact'

export default {
  data() {
    return {
      form: {
        user_name: '',
        contents: '',
        from: '',
        mobile: '',
      },
      formRules: {
        user_name: [
          { required: true, message: '姓名为必填项', trigger: 'blur' },
          { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    userSubmit() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          try {
            await addContents(this.form)

            this.$message.success('提交成功')

            for (const key in this.form) {
              this.form[key] = ''
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {

  }
}
</script>

<style lang="scss">

</style>
